import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SettingsManageUsersComponent } from '@app/components/sections/settings/manage-users/manage-users.component';
import { SettingsGroupsMainComponent } from '@app/components/sections/settings/groups/main/main.component';
import { SettingsAccessTokensMainComponent } from '@app/components/sections/settings/access-tokens/main/main.component';
import { SettingsVersionStatusMainComponent } from '@app/components/sections/settings/version-status/main/main.component';
import { SettingsLabelsGroupsMainComponent } from '@app/components/sections/settings/labels-groups/main/main.component';
import { SettingsRulesMainComponent } from '@app/components/sections/settings/rules/main/main.component';
import { SettingsRulesMainEditComponent } from '@app/components/sections/settings/rules/main-edit/main-edit.component';
import { SettingsManageUsersAddComponent } from '@app/components/sections/settings/users/main-add/main-add.component';

import { SettingsWorkflowsMainComponent } from '@app/components/sections/settings/workflows/main/main.component';
import { SettingsWorkflowsMainEditComponent } from '@app/components/sections/settings/workflows/main-edit/main-edit.component';
import { SettingsMainComponent } from '@app/components/sections/settings/settings-main/main/main.component';
// import { ProfileMainComponent } from '@app/components/sections/profile/main/main.component';
import { SettingsOrganizationProfileMainComponent } from '@app/components/sections/settings/organization-profile/main/main.component';
import { SettingsFormsMainComponent } from '@app/components/sections/settings/forms/main/main.component';
import { SettingsFormsMainEditComponent } from '@app/components/sections/settings/forms/main-edit/main-edit.component';
import { LeaveFormEditorGuard} from '@app/components/sections/settings/forms/form/leave-form/leave-form.guard';

export const settingsAppRoutes : Routes = [
    // {
    //     path: 'profile',
    //     component: ProfileMainComponent
    // },
    {
        path: 'settings',
        component: SettingsMainComponent
    },
    {  
        path: 'settings/organization-profile',
        component: SettingsOrganizationProfileMainComponent
    },
    {
        path: 'settings/users',
        component: SettingsManageUsersComponent
    },
    {
        path: 'settings/users/add',
        component: SettingsManageUsersAddComponent
    },
    {
        path: 'settings/groups',
        component: SettingsGroupsMainComponent
    },
    {
        path: 'settings/access-tokens',
        component: SettingsAccessTokensMainComponent
    },
    {
        path: 'settings/version-status',
        component: SettingsVersionStatusMainComponent
    },
    {
        path: 'settings/categories',
        component: SettingsLabelsGroupsMainComponent
    },
    {
        path: 'settings/rules',
        component: SettingsRulesMainComponent
    },
    {
        path: 'settings/rules/add',
        component: SettingsRulesMainEditComponent
    },
    {
        path: 'settings/rules/:id',
        component: SettingsRulesMainEditComponent
    },
    {
        path: 'settings/workflows',
        component: SettingsWorkflowsMainComponent
    },
    {
        path: 'settings/workflows/:id',
        component: SettingsWorkflowsMainEditComponent
    },
    {
        path: 'settings/forms',
        component: SettingsFormsMainComponent
    },
    {
        path: 'settings/forms/add',
        component: SettingsFormsMainEditComponent,
        canDeactivate: [LeaveFormEditorGuard]
    },
    {
        path: 'settings/forms/:id',
        component: SettingsFormsMainEditComponent,
        canDeactivate: [LeaveFormEditorGuard]
    },
];


@NgModule({
  imports: [
      RouterModule.forRoot(settingsAppRoutes)
  ],
  exports: [RouterModule]
})
export class AppSettingsRouterModule { }
